import React, { useState } from "react";
import { useCallback } from "react";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from "recharts";
import GraphLabel3 from "../../Components/GraphLabel3";

const data = [
    { name: "78.2%", value: 800 },
    { name: "28.2%", value: 200 },
    { name: "38.2%", value: 200 },
  ];

const LogisticsPieChart = () => {
  return (
    <>
      <div className="graph">
        <div className="graph_heading">
          <h1 className="Graph_title">WAREHOUSE OPERATING COST DISTRIBUTION</h1>
        </div>
      </div>
      <GraphLabel3 color={["#4E6DCB", "#20BF55","#E15759"]} 
            value={['Category 1', 'Category 2','Category 3']}
          />
      <div className="bi-pie-chart">
        <LogisticsCircle />
        <div className="bi-pie-chart-table">
          <h3>Category 1</h3>
          <div className="bi-table-data">
            <div className="bi-table-data-col">
              <p>Sales Percentage:</p>
              <p>31.04%</p>
            </div>
            <div className="bi-table-data-col">
              <p>Number of sales:</p>
              <p>10,000</p>
            </div>
            <div className="bi-table-data-col">
              <p>Order received:</p>
              <p>8,000</p>
            </div>
            <div className="bi-table-data-col">
              <p>Number of sales:</p>
              <p>10,000</p>
            </div>
            <div className="bi-table-data-col">
              <p>Order received:</p>
              <p>8,000</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogisticsPieChart;

const COLORS = ["#4E6DCB", " #E15759", "#20BF55"];
function handleClick(){
  console.log('hi')
}
const renderActiveShape = (props) => {

  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill="#000">
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={52}
        outerRadius={88}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  );
};

const LogisticsCircle = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const onPieEnter = useCallback(
    (_, index) => {
      setActiveIndex(index);
    },
    [setActiveIndex]
  );

  return (
    <div style={{height:'200px', width:'230px'}}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart >
          <Pie
            activeIndex={activeIndex}
            activeShape={renderActiveShape}
            data={data}
            cx={120}
            cy={100}
            innerRadius={55}
            outerRadius={85}
            fill="#8884d8"
            dataKey="value"
            onMouseEnter={onPieEnter}
            isAnimationActive={false}
          >
            {data.map((entry, index) => (
              <Cell on={handleClick} key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};


